import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export default function Header() {
  const nav = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const go = (path: string) => {
    nav(path);
    setMenuOpen(false); // 메뉴 닫기
  };

  return (
    <header className="w-full px-5 py-3 flex justify-between items-center bg-white shadow-sm relative z-50">
      <div
        className="font-bold text-xl cursor-pointer select-none"
        onClick={() => go("/")}
      >
        Opticon
      </div>
      {/* 데스크탑 메뉴 */}
      <nav className="hidden md:flex gap-4 items-center font-medium">
        <button onClick={() => go("/works")}>works</button>
        <div>|</div>
        <button onClick={() => go("/articles")}>articles</button>
        <div>|</div>
        <button onClick={() => go("/education")}>education</button>
        <div>|</div>
        <button onClick={() => go("/architon")}>🚀architon</button>
      </nav>
      {/* 모바일 햄버거 */}
      <button
        className="md:hidden p-2"
        onClick={() => setMenuOpen((v) => !v)}
        aria-label="메뉴 열기"
      >
        {menuOpen ? <X size={28} /> : <Menu size={28} />}
      </button>
      {/* 모바일 메뉴 오버레이 */}
      {menuOpen && (
        <div className="absolute top-full right-0 mt-2 w-40 bg-white shadow-lg rounded-lg flex flex-col items-stretch py-2 md:hidden z-50">
          <button
            className="py-2 px-4 text-left hover:bg-gray-100"
            onClick={() => go("/works")}
          >
            works
          </button>
          <button
            className="py-2 px-4 text-left hover:bg-gray-100"
            onClick={() => go("/articles")}
          >
            articles
          </button>
          <button
            className="py-2 px-4 text-left hover:bg-gray-100"
            onClick={() => go("/education")}
          >
            education
          </button>
          <button
            className="py-2 px-4 text-left hover:bg-gray-100"
            onClick={() => go("/architon")}
          >
            🚀architon
          </button>
        </div>
      )}
    </header>
  );
}
